import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'nc-img-enlargement',
  templateUrl: './img-enlargement.component.html',
  styleUrls: ['./img-enlargement.component.less']
})
export class ImgEnlargementComponent implements OnInit {
  @Input() ncSmallSize: number = 300;//缩略图容器大小
  @Input() ncPreviewSize: number = 600;//预览容器大小
  @Input() ncSmallUrl: string = '';//缩略图地址
  @Input() ncPreviewUrl: string = '';//预览图地址

  constructor(private eleRef: ElementRef) { }

  ngOnInit(): void {
    let el_EnlargeContainer = this.eleRef.nativeElement.querySelector('#el_EnlargeContainer');
    let el_SmallContainer = this.eleRef.nativeElement.querySelector('#el_SmallContainer');
    let el_SmallImage = this.eleRef.nativeElement.querySelector('#el_SmallImage');
    let el_maskEnarge = this.eleRef.nativeElement.querySelector('#el_maskEnarge');
    let el_PreviewContainer = this.eleRef.nativeElement.querySelector('#el_PreviewContainer');
    let el_PreviewImage = this.eleRef.nativeElement.querySelector('#el_PreviewImage');

    let smallImgWidth: number = 0;
    let smallImgHeight: number = 0;

    el_SmallImage.src = this.ncSmallUrl;
    el_SmallImage.onload = () => {
      //计算缩放比
      let { width, height } = el_SmallImage;
      const smallScale = Math.min(this.ncSmallSize / width, this.ncSmallSize / height, 1);

      //计算左侧区域宽高
      smallImgWidth = width * smallScale;
      smallImgHeight = height * smallScale;

      //设置左侧区域宽高
      el_EnlargeContainer.style.width = el_SmallContainer.style.width = el_SmallImage.style.width = smallImgWidth + 'px';
      el_EnlargeContainer.style.height = el_SmallContainer.style.height = el_SmallImage.style.height = smallImgHeight + 'px';
    }


    el_SmallContainer.onmouseenter = async () => {
      // 加载预览大图原始图
      if (this.ncPreviewUrl) {
        el_PreviewImage.src = this.ncPreviewUrl;
      } else {
        el_PreviewImage.src = this.ncSmallUrl;
      }

      el_PreviewImage.onload = () => {
        // 显示蒙层和预览大图区域
        el_maskEnarge.style.display = 'block';
        el_PreviewContainer.style.display = 'block';

        //计算缩放比
        let { width, height } = el_PreviewImage;
        const previewScale = Math.min(this.ncPreviewSize / width, this.ncPreviewSize / height, 1);

        //计算实际展示区域
        el_PreviewContainer.style.width = width * previewScale + 'px';
        el_PreviewContainer.style.height = height * previewScale + 'px';
        el_PreviewContainer.style.left = (smallImgWidth + 10) + 'px';

        //设置蒙层的大小，使用预览大图的缩放比，才能得到准确的蒙层内容用于在右侧放大区域呈现放大效果
        el_maskEnarge.style.width = smallImgWidth * previewScale + 'px';
        el_maskEnarge.style.height = smallImgHeight * previewScale + 'px';
      }
    }

    el_SmallContainer.onmouseleave = () => {
      el_maskEnarge.style.display = 'none';
      el_PreviewContainer.style.display = 'none';
    }

    el_SmallContainer.onmousemove = (event: any) => {
      //获取鼠标移动的位置信息
      let x = event.pageX - el_EnlargeContainer.getBoundingClientRect().left - el_maskEnarge.offsetWidth / 2;
      let y = event.pageY - el_EnlargeContainer.getBoundingClientRect().top - el_maskEnarge.offsetHeight / 2;

      //限制蒙层移动的范围，不能超出缩略小图内容区域
      const xMax = el_SmallContainer.offsetWidth - el_maskEnarge.offsetWidth;
      x = x < 0 ? 0 : (x > xMax ? xMax : x);
      const yMax = el_SmallContainer.offsetHeight - el_maskEnarge.offsetHeight;
      y = y < 0 ? 0 : (y > yMax ? yMax : y);

      //更新蒙层的位置信息，实时移动蒙层元素
      el_maskEnarge.style.left = x + 'px';
      el_maskEnarge.style.top = y + 'px';

      //右侧的预览大图等比例移动
      const rate = el_PreviewImage.offsetWidth / el_SmallContainer.offsetWidth;
      el_PreviewImage.style.marginTop = -(rate * y) + 'px';
      el_PreviewImage.style.marginLeft = -(rate * x) + 'px';
    }
  }

}
